import React from 'react';
import './styles.scss';
import MultipleProgressBar from '../MultipleProgressBar/MultipleProgressBar';
import { acquisitionProductStatusColors } from '../../view/Common/NomenclatureItems';
import { useTranslation } from 'react-i18next';
import { MAX_SUBPRODUCTS_PER_COMPONENT } from '../../utils/Constants/ProjectReportConstants';

export const AcquisitionProcessProduct = ({ productComponent, subproducts, isUniqueComponent }) => {
  const { t } = useTranslation();

  const getProgressBarData = (item, isSubproduct) => {
    return {
      completed: !isSubproduct ? item.contractPercent : item.contractPercentProduct,
      pending: !isSubproduct ? item.pendingPercent : item.pendingPercentProduct,
      unassign: !isSubproduct ? item.unallocatedPlanPercent : item.unallocatedPlanProduct,
    }
  }

  return (
    <div className='product-card'>
      <div className='product-title'>
        <span className='product-item-content'>{`${t('new_component')} ${productComponent.componentNumber}`}</span>
        <MultipleProgressBar data={getProgressBarData(productComponent, false)} options={acquisitionProductStatusColors} />
      </div>
      <div className={(subproducts.length >= MAX_SUBPRODUCTS_PER_COMPONENT && isUniqueComponent) ? 'product-expanded' : ''}>
        {
          subproducts?.map((item, index) => {
            return (
              <div className='product-item' key={index}>
                <span className='product-item-content'>{item.outputNM}</span>
                <MultipleProgressBar data={getProgressBarData(item, true)} options={acquisitionProductStatusColors} />
              </div>
            )
          })
        }
      </div>
    </div>
  )
}
